import {ChartsService} from "../../serverService/charts/ChartsService";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    addNewRowToTable,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable,
    RaikoDefaultDialogPage, RaikoGridOneColumn, RaikoTableTitleContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RouteHelper} from "../../route/RouteHelper";
import SiteCreateChart from "./SiteCreateChart";

export default function SiteCharts() {

    let page = 0
    const size = 25

    const service = new ChartsService()

    const [totalItems, setTotalItems] = useState("")
    const [charts, setCharts] = useState([]);
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0);

    const navigate = useNavigate()

    useEffect(() => {
        getDataFromServer()
    }, []);


    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getCharts(
            page, size
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setCharts([])
            response.data.map((item, index) => {
                setCharts(prev => [
                    ...prev,
                    prepareSliderItem(
                        item.id,
                        (page * size) + index + 1,
                        item.title,
                        item.postedBy,
                        item.enabled
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function prepareSliderItem(id, number, title, postedBy, enabled) {
        return {
            id,
            number,
            title,
            postedBy: postedBy
        }
    }

    function handleSelectRow(_item) {
        let _title = ""
        charts.map((item) => {
            if (item.id === _item)
                _title = item.name
        })

        navigate(
            RouteHelper.MagazineChartDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )
    }

    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    function handleAddChartToTable(item) {
        const newCharts = addNewRowToTable(
            prepareSliderItem(
                item.id,
                1,
                item.title,
                item.postedBy,
                item.enabled
            ),
            charts
        )


        setCharts(newCharts)
        handleCloseDialog()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن اسلاید جدید"}
            >
                <SiteCreateChart handleAddChartToTable={handleAddChartToTable}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Magazine.name,
                        ""
                    ),
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.MagazineCharts.name,
                        RouteHelper.MagazineCharts.url
                    )
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اسلایدر"}
                            amount={totalItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={charts}
                            isLoading={tableLoading}
                            newPage={page}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "postedBy",
        label: "سازنده"
    },
]
